'use client'

import { IArticle } from '@/api/interfaces/IArticle'
import { GenericLink } from '../GenericLink'
import { Icon } from '../Icon'
import { MoreButton } from '../buttons/MoreButton'
import { Shareable } from '../buttons/ShareButton'
import { ArticleApi } from '@/api/article'
import { useRouter } from 'next/navigation'
import { WithT } from '@/locales/types'
import { useDialogStore } from '../dialog/FullScreenBackDrop'
import { useAuthStore } from '@/store/auth'
import { createT } from '@/locales/index'
import { useArticleState } from '@/store/client'

type ArticleActionsProps = {
  article: IArticle.IArticleRO
}

export function ArticleActions({
  article,
  translations,
}: WithT<ArticleActionsProps>) {
  const router = useRouter()
  const dialog = useDialogStore()
  const authUser = useAuthStore()
  const t = createT(translations)

  const { state, set } = useArticleState(article.id, article)

  const reportMenu = [
    {
      id: 'REPORT',
      text: t('report'),
    },
  ]

  const editMenu = [
    {
      id: 'EDIT',
      text: t('edit'),
    },
    {
      id: 'DELETE',
      text: t('delete'),
    },
  ]

  const isEditable = article.writer.username === authUser.user?.username

  const menu = isEditable ? editMenu : reportMenu

  const handleMenuClick = async (id: string) => {
    if (id === 'EDIT') {
      router.push(`/article/edit?articleId=${article.id}`)
    }

    if (id === 'DELETE') {
      await ArticleApi().delete(article.id)

      router.replace(
        `/@${authUser.user?.username}?profile-tab=ACTIVITY&sub-tab=ARTICLE`,
      )
    }

    if (id === 'REPORT') {
      dialog.push('report')
    }
  }

  const handleBookmarkClick = async () => {
    set(await ArticleApi().bookmark(article.id))
  }

  return (
    <>
      <GenericLink onClick={handleBookmarkClick} privilege>
        <Icon
          name={state.isBookmark ? 'bookmark-fill' : 'bookmark'}
          size={24}
        />
      </GenericLink>

      <Shareable>
        <Icon name="share" size={24} />
      </Shareable>

      <MoreButton menu={menu} onClick={handleMenuClick} />
    </>
  )
}
